import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'cpcs-reconnect';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form';
import cx from 'classnames';
import FormRowField from 'pages/common/newPage/form/elements/FormRowField';
import { FORM_BILLING } from 'domain/const';
import { validator, rules } from 'components/form/validation';

import I from 'immutable';
import { saveBillingAction } from 'domain/env/EnvActions';

import { user_sel } from 'domain/env/EnvModel';
import { countriesValidSel, USAIdSelector } from 'domain/country/CountryModel';
import Select from 'components/form/select';

import injectSheet from 'lib/sheet';
import styles from './sheet.js';

const submit = (data, dispatch, props) => {
  if (props.hideActionButtons) return;
  dispatch(saveBillingAction(data));
};

class AddressForm extends React.PureComponent {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    pristine: PropTypes.bool,
    hideActionButtons: PropTypes.bool,
    fixDropdownPadding: PropTypes.bool,
    modifier: PropTypes.string,
    countryList: PropTypes.any,
  };

  static defaultProps = {
    countryList: [],
  };

  validation = {
    email: validator(
      rules.cmRequired('Email is required'),
      rules.email,
    ),
    code: rules.cmRequired('Zip code is required'),
    country: rules.cmRequired('Country is required'),
  }

  render() {
    const { classes, handleSubmit, pristine, hideActionButtons, modifier, countryList, fixDropdownPadding } = this.props;
    return (
      <form
        className={classes.AddressForm}
        onSubmit={handleSubmit}
      >
        <h4
          className={cx(classes.formTitle, modifier)}
          children="Billing Information"
        />
        <Field
          name="email"
          id="billing-email"
          placeholder="Email"
          component={FormRowField}
          rootTag="div"
          modifier="billingPageField"
          validate={this.validation.email}
        />
        <Field
          name="country"
          id="billing-country"
          placeholder="Country"
          validate={this.validation.country}
          component={FormRowField}
          Field={Select}
          list={countryList}
          isClearable={false}
          modifier={'billingPageField--Country'}
          SelectStyleKey="BillingCountryField"
          fixDropdownPadding={fixDropdownPadding}
        />
        <Field
          name="code"
          placeholder="Zip Code"
          component={FormRowField}
          rootTag="div"
          modifier="billingPageField"
          validate={this.validation.code}
        />
        {
          !hideActionButtons &&
            <div className={classes.actions}>
              <button
                className={cx(classes.submit, 'addressForm')}
                children="update"
                disabled={pristine}
              />
            </div>
        }
      </form>
    );
  }
}

const initialValues = (profile = {}, USA_ID) => (['email', 'code', 'country']
  .reduce((acc, key) => ({ ...acc, [key]: profile[key] || acc[key] }), { country: USA_ID }));

function passInitialValues(WrappedComponent) {
  function PassInitialValues(props) {
    if (!props.USA_ID) return null;
    return (
      <WrappedComponent
        {...props}
        initialValues={initialValues(props.userProfile.toJS(), props.USA_ID)}
      />
    );
  }
  PassInitialValues.propTypes = {
    userProfile: PropTypes.instanceOf(I.Record).isRequired,
    USA_ID: PropTypes.number,
  };
  return PassInitialValues;
};

export default compose(
  connect({
    userProfile: user_sel,
    USA_ID: USAIdSelector,
    countryList: countriesValidSel,
  }),
  passInitialValues,
  reduxForm({
    form: FORM_BILLING,
    onSubmit: submit,
  }),
  injectSheet(styles),
)(AddressForm);
